import { render, staticRenderFns } from "./ProductMenuGrid.vue?vue&type=template&id=1bb0469e&scoped=true"
import script from "./ProductMenuGrid.vue?vue&type=script&lang=js"
export * from "./ProductMenuGrid.vue?vue&type=script&lang=js"
import style0 from "./ProductMenuGrid.vue?vue&type=style&index=0&id=1bb0469e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb0469e",
  null
  
)

export default component.exports